/**
 * Constants for use in studio
 * @module
 */
import type { StudioDocUserRole } from "api-types/modelTypes";

export enum StudioGeneralModals {
  DOC_MISSING_REFERENCES = "doc-missing-references",
  DOC_INFO = "doc-info",
}

export const HOME_BREADCRUMB = "Home";

export const COMMAND_PALETTE_ICON_BUTTON_ID = "command-palette-icon-button";
export const STUDIO_LOGS_PREVIEW_ID = "studio-logs-preview";
export const STUDIO_LOGS_PANEL_ID = "studio-logs-panel";

export const STUDIO_ENTITY_HASH_DATA_ATTRIBUTE = "data-studio-entity-hash";
/** Searchable / row-header label on explorer entity rows (ExplorerEntityNode / Tile). */
export const STUDIO_ENTITY_LABEL_DATA_ATTRIBUTE = "data-studio-entity-label";

export const NAV_ID_PREFIX = "NAV_";

const STUDIO_MENU_NODE_ATTRIBUTE_PREFIX = "data-studio-menu-node";
export const STUDIO_MENU_NODE_KIND_ATTRIBUTE = `${STUDIO_MENU_NODE_ATTRIBUTE_PREFIX}-kind`;
export const STUDIO_MENU_NODE_ID_ATTRIBUTE = `${STUDIO_MENU_NODE_ATTRIBUTE_PREFIX}-id`;

export const STUDIO_VIEWPORT_TAB_ATTRIBUTE_PREFIX = "data-studio-viewport-tab";
export const STUDIO_VIEWPORT_TAB_ID_ATTRIBUTE = `${STUDIO_VIEWPORT_TAB_ATTRIBUTE_PREFIX}-id`;

export const STUDIO_ENTITY_FIELD_ATTRIBUTE_PREFIX = "data-studio-entity-field";
export const STUDIO_CONTEXT_MENU_EVENT = "studiocontextmenu";

export const STUDIO_SAVE_DELAY_TIME = 1500;

export const studioDocUserRoleDescriptions: { [key in StudioDocUserRole]: string } = {
  viewer: "may view the Home in Readonly mode",
  editor: "may edit this Home but not control its user permissions",
  owner: "may control all user permissions on this Home",
};

export enum StudioBrowserTabs {
  EXPLORER = "Explorer",
  VIEWS = "Views",
  ENGINE = "Engine",
  LIVE_PLANS = "Live Plans",
  // TODO: remove when userDefinedPlansetsEnabled flag is removed
  PLANS = "Plans",

  MATERIALS = "Materials",
  CONTEXT = "Context",
  OPTIONS = "Options",

  INSPECTOR = "Inspector",
  CATALOGS = "Catalogs",

  ACTIVE_OPTIONS = "Active Options",
  PRESETS = "Option Presets",
}

export const STUDIO_TAB_CHANGE_EVENT = "studioTabChange";
